import React from "react";
import "./components/Contact.css";

const ContactPage = () => {
  return (
    <section className="contact-page">
      <div className="container contact-wrapper">

        <div className="contact-header">
          <h1>Let’s Start a Conversation</h1>
          <p>
            If you are exploring AI strategy, marketing advisory, innovation initiatives,
            research-led decision support, or digital growth direction,
            we would be pleased to hear from you.
          </p>
        </div>

        <div className="contact-card glass-card-bg">
          <form className="contact-form">

            <div className="form-row">
              <input type="text" placeholder="Name" required />
              <input type="text" placeholder="Company" />
            </div>

            <div className="form-row">
              <input type="email" placeholder="Email" required />
              <input type="text" placeholder="Phone / WhatsApp" />
            </div>

            <div className="form-row full">
              <select required>
                <option value="">Area of Interest</option>
                <option>AI Consulting</option>
                <option>Marketing Consultancy</option>
                <option>Strategy Advisory</option>
                <option>Research & Insights</option>
                <option>Digital Content / Website Advisory</option>
                <option>Innovation Collaboration</option>
                <option>General Enquiry</option>
              </select>
            </div>

            <div className="form-row full">
              <textarea
                rows="5"
                placeholder="Message"
                required
              ></textarea>
            </div>

            <button type="submit" className="contact-btn">
              Submit
            </button>

          </form>
        </div>

      </div>
    </section>
  );
};

export default ContactPage;